module.exports = __webpack_public_path__ + "img/advent_birds_desktop_right.93ef437b.svg";